// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__1PZ8A","en-custom-excerpt":"organism1-m__en-custom-excerpt__3HAID","en-custom-subheadline":"organism1-m__en-custom-subheadline__2PlIi"};